import type { IPersonData } from '../../../../models/person-data.model';
import type { AddressApiModel } from './adress.api-model';

export class PersonDataApiModel {
  valid!: boolean;
  personalIdentityNumber!: string;
  firstName!: string;
  lastName!: string;
  address!: AddressApiModel;

  public static mapToBusinessModel(apiModel: PersonDataApiModel): IPersonData {
    return {
      valid: apiModel.valid,
      personalIdentityNumber: apiModel.personalIdentityNumber,
      firstName: apiModel.firstName,
      lastName: apiModel.lastName,
      address: apiModel?.address ?? null,
    };
  }
}

